/* eslint-disable */
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const OrderCardPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The current order
   */
  currentOrder: PropTypes.any,

  /**
   * The `history` props from `react-router`
   */
  history: ReactRouterPropTypes.history.isRequired,

  /**
   * The order id
   */
  orderId: PropTypes.string,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
};

export default OrderCardPropTypes;
